export enum MouseButton {
  Left,
  Middle,
  Right,
  BrowserBack,
  BrowserForward,
}
